import { date, number, object, string } from "yup";

export const getValidation = () => {
  const validationSchema = object({
    license: number()
      .nullable()
      .required("License Type can’t be blank.")
      .default(null),
    licensePeriod: string()
      .nullable()
      .default(null),
    organization: number()
      .nullable()
      .required()
      .default(null),
    price: number()
      .required("Order Price can’t be blank.")
      .nullable()
      .transform(value => (Number.isNaN(value) ? 0 : value))
      .default(null),
    startDate: date()
      .nullable()
      .required("Start Date can’t be blank.")
      .default(null),
    expirationDate: date()
      .nullable()
      .required("Expiration Date can’t be blank.")
      .default(null)
  });

  return {
    validationSchema,
    emptyDefaultValues: validationSchema.cast({})
  };
};
